import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

type SectionHeaderProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  actions?: ReactNode;
};

export function SectionHeader({ icon: Icon, title, description, actions }: SectionHeaderProps) {
  return (
    <div className="dashboard-overview-card__header">
      <div className="section-heading">
        <span className="section-heading__icon">
          <Icon size={18} />
        </span>
        <div className="section-heading__copy">
          <p className="section-heading__title">{title}</p>
          <p className="section-copy">{description}</p>
        </div>
      </div>

      {actions ? <div className="dashboard-overview-card__actions">{actions}</div> : null}
    </div>
  );
}